module.exports = __webpack_public_path__ + "img/hok6.b17f4921.png";